<p>equipment-list works!</p>
